module.exports = __webpack_public_path__ + "img/Recursamiento.bb560354.svg";